export function trackModel(_index: number, model: { id: number | string }): number | string {
    return model.id;
}

export function stringifyErr(err: any): string {
    if (!err) {
        return '';
    }

    // Helper function to strip HTML tags from a string.
    const stripHtml = (str: string): string => {
        return str.replace(/<[^>]*>/g, '').trim();
    };

    // If the error is a string, try to strip HTML tags if present.
    if (typeof err.error === 'string') {
        const cleaned = stripHtml(err.error);
        return cleaned.length > 0 ? cleaned : err.error;
    }

    let out = '';

    // If err.error is an object, process its values.
    if (err.error != null && typeof err.error === 'object') {
        Object.values(err.error).forEach((val) => {
            let part = '';
            if (Array.isArray(val)) {
                part = val.map(element => typeof element === 'string' ? stripHtml(element) : JSON.stringify(element)).join(', ');
            } else if (typeof val === 'string') {
                part = stripHtml(val);
            } else {
                part = JSON.stringify(val);
            }
            if (out.length > 0 && part) {
                out += ', ' + part;
            } else if (part) {
                out = part;
            }
        });
    }

    return out;
}

export function resizeImage(file: File, maxHeight?: number, maxWidth?: number): Promise<Blob | null> {
    return new Promise((resolve, reject) => {
        let image = new Image();
        image.src = URL.createObjectURL(file);
        image.onload = () => {
            let width = image.width;
            let height = image.height;
            const newMaxWidth = maxWidth ?? width;
            const newMaxHeight = maxHeight ?? height;

            if (width <= newMaxWidth && height <= newMaxHeight) {
                resolve(file);
            }

            let newWidth;
            let newHeight;

            //Scale for new max width
            newHeight = height * (newMaxWidth / width);
            newWidth = newMaxWidth;
            //Scale width some more if height does not satisfy the constraint
            if (newHeight > newMaxHeight) {
                newWidth = newWidth * (newMaxHeight / newHeight);
                newHeight = newMaxHeight;
            }

            let canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;

            canvas.getContext('2d')?.drawImage(image, 0, 0, newWidth, newHeight);
            canvas.toBlob(resolve, file.type);
        };
        image.onerror = reject;
    });
}
